"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ImageDisplay;
exports.GIFDisplay = exports.JPEGDisplay = exports.PNGDisplay = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

function ImageDisplay(props) {
  var size = {};

  if (props.metadata) {
    var _props$metadata = props.metadata,
        width = _props$metadata.width,
        height = _props$metadata.height;
    size = {
      width: width,
      height: height
    };
  }

  return _react["default"].createElement("img", (0, _extends2["default"])({
    alt: "",
    src: "data:".concat(props.mimetype, ";base64,").concat(props.data)
  }, size));
}

var PNGDisplay = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(PNGDisplay, _React$Component);

  function PNGDisplay() {
    (0, _classCallCheck2["default"])(this, PNGDisplay);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PNGDisplay).apply(this, arguments));
  }

  (0, _createClass2["default"])(PNGDisplay, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(ImageDisplay, (0, _extends2["default"])({
        mimetype: "image/png"
      }, this.props));
    }
  }]);
  return PNGDisplay;
}(_react["default"].Component);

exports.PNGDisplay = PNGDisplay;
(0, _defineProperty2["default"])(PNGDisplay, "MIMETYPE", "image/png");

var JPEGDisplay = /*#__PURE__*/function (_React$Component2) {
  (0, _inherits2["default"])(JPEGDisplay, _React$Component2);

  function JPEGDisplay() {
    (0, _classCallCheck2["default"])(this, JPEGDisplay);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(JPEGDisplay).apply(this, arguments));
  }

  (0, _createClass2["default"])(JPEGDisplay, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(ImageDisplay, (0, _extends2["default"])({
        mimetype: "image/jpeg"
      }, this.props));
    }
  }]);
  return JPEGDisplay;
}(_react["default"].Component);

exports.JPEGDisplay = JPEGDisplay;
(0, _defineProperty2["default"])(JPEGDisplay, "MIMETYPE", "image/jpeg");

var GIFDisplay = /*#__PURE__*/function (_React$Component3) {
  (0, _inherits2["default"])(GIFDisplay, _React$Component3);

  function GIFDisplay() {
    (0, _classCallCheck2["default"])(this, GIFDisplay);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(GIFDisplay).apply(this, arguments));
  }

  (0, _createClass2["default"])(GIFDisplay, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(ImageDisplay, (0, _extends2["default"])({
        mimetype: "image/gif"
      }, this.props));
    }
  }]);
  return GIFDisplay;
}(_react["default"].Component);

exports.GIFDisplay = GIFDisplay;
(0, _defineProperty2["default"])(GIFDisplay, "MIMETYPE", "image/gif");